import React from "react";

const Button = () => {
  return (
    <div className="flex flex-col items-center justify-center gap-4 border-l border-lightGray">
      <button className="rounded-lg bg-primary px-8 py-2.5 text-white">
        View
      </button>
    </div>
  );
};

export default Button;
